// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"df48659a","795":"1ad5e593"}[chunkId] + ".chunk.js";
};